
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { pipe } from "fp-ts/function";
import { fold } from "fp-ts/Either";

import { Variable } from "@/oxygen/variables/lib/types";
import { GradientColorV } from "@/types/colors";
import {
  getVariablePreviewValue,
  resolveGlobalVariableValueRecursively,
  variableOrOverride
} from "@/oxygen/variables/lib/utils";

import ColorSwatch from "@/components/Reusable/CustomInputs/Color/ColorSwatch.vue";
import VariableIcon from "@/oxygen/variables/VariableIcon.vue";

@Component({
  components: {
    VariableIcon,
    ColorSwatch
  }
})
export default class VariableChooserList extends Vue {
  @Prop({
    default() {
      return [];
    }
  })
  variables!: Variable[];

  @Prop({
    default() {
      return [];
    }
  })
  overrideVariables!: Variable[];

  @Prop()
  selectedVariable?: Variable;

  @Prop({ default: 10 })
  iconSize!: number;

  isVariableSelected(globalVariable: Variable) {
    return this.selectedVariable?.id === globalVariable.id;
  }

  getOverrideVariable(variable: Variable) {
    return this.overrideVariables.find(v => v.id === variable.id);
  }

  previewValue(variable: Variable) {
    const overrideVariable = this.getOverrideVariable(variable);
    return getVariablePreviewValue(variable, overrideVariable) || "-";
  }

  colorCode(variable: Variable) {
    const overrideVariable = this.getOverrideVariable(variable);

    const value = resolveGlobalVariableValueRecursively(
      variableOrOverride(variable, overrideVariable)
    );

    if (variable.type === "color") {
      return pipe(
        value,
        GradientColorV.decode,
        fold(
          () => value,
          gradient => gradient.value
        )
      );
    }

    return "";
  }
}
